import OverlayEffect from './OverlayEffect';

export const EffectIndex = {
    BACKGROUND: 0,
    HIGHLIGHTS: 1,
};

export default {
    /* Backgrounds */
    // Original: new OriginalEffect(),

    /* Highlights */
    Overlay: new OverlayEffect(),
};
